import * as XLSX from 'xlsx';

export interface XlsxExportOptions {
  filename: string;
  sheetName?: string;
  columnWidths?: number[];
}

/**
 * Gera download de XLSX a partir de uma lista de objetos.
 * Cada item vira uma linha, as chaves do primeiro item viram cabeçalhos.
 */
export function exportToXlsx<T extends Record<string, unknown>>(
  rows: T[],
  options: XlsxExportOptions,
): void {
  if (rows.length === 0) return;

  const ws = XLSX.utils.json_to_sheet(rows);

  if (options.columnWidths && options.columnWidths.length > 0) {
    ws['!cols'] = options.columnWidths.map((wch) => ({ wch }));
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, options.sheetName ?? 'Dados');

  const dateStr = new Date().toISOString().slice(0, 10);
  const name = options.filename.endsWith('.xlsx')
    ? options.filename
    : `${options.filename}-${dateStr}.xlsx`;
  XLSX.writeFile(wb, name);
}

/** Helper: converte centavos em number formatado para Excel (mantém número, não string). */
export function centsToNumber(cents: number | null | undefined): number {
  if (cents == null) return 0;
  return Math.round(cents) / 100;
}

/** Helper: ISO → dd/mm/yyyy. */
export function isoToBrDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** Helper: ISO → dd/mm/yyyy hh:mm. */
export function isoToBrDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
